import { render, staticRenderFns } from "./phieu-luong-item.vue?vue&type=template&id=7680ecaa"
import script from "./phieu-luong-item.vue?vue&type=script&lang=js"
export * from "./phieu-luong-item.vue?vue&type=script&lang=js"
import style0 from "./phieu-luong-item.vue?vue&type=style&index=0&id=7680ecaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports